export default "__VITE_ASSET__CzEbcpYK__"